document.addEventListener('DOMContentLoaded', function () {

  /* =========================
     PRODUCT GALLERY SLIDER
  ========================= */

  const track =
    document.querySelector('.custom-pdp__slider-track');

  if (track) {

    const slides =
      document.querySelectorAll('.custom-pdp__slide');

    const thumbs =
      document.querySelectorAll('.custom-pdp__thumb');

    const nextBtn =
      document.querySelector('.custom-pdp__arrow.next');

    const prevBtn =
      document.querySelector('.custom-pdp__arrow.prev');

    let currentIndex = 0;

    function updateSlider() {

      track.style.transform =
        `translateX(-${currentIndex * 100}%)`;

      thumbs.forEach((thumb) => {
        thumb.classList.remove('active');
      });

      if (thumbs[currentIndex]) {
        thumbs[currentIndex].classList.add('active');
      }

    }

    /* THUMBNAIL CLICK */

    thumbs.forEach((thumb) => {

      thumb.addEventListener('click', function () {

        currentIndex =
          parseInt(this.dataset.index);

        updateSlider();

      });

    });

    /* NEXT BUTTON */

    if (nextBtn) {

      nextBtn.addEventListener('click', function () {

        currentIndex++;

        if (currentIndex >= slides.length) {
          currentIndex = 0;
        }

        updateSlider();

      });

    }

    /* PREV BUTTON */

    if (prevBtn) {

      prevBtn.addEventListener('click', function () {

        currentIndex--;

        if (currentIndex < 0) {
          currentIndex = slides.length - 1;
        }

        updateSlider();

      });

    }

    /* TOUCH SWIPE */

    let startX = 0;
    let endX = 0;

    track.addEventListener('touchstart', (e) => {

      startX = e.touches[0].clientX;

    });

    track.addEventListener('touchmove', (e) => {

      endX = e.touches[0].clientX;

    });

    track.addEventListener('touchend', () => {

      const difference = startX - endX;

      if (difference > 50) {

        currentIndex++;

        if (currentIndex >= slides.length) {
          currentIndex = 0;
        }

      }

      if (difference < -50) {

        currentIndex--;

        if (currentIndex < 0) {
          currentIndex = slides.length - 1;
        }

      }

      updateSlider();

    });

  }

  /* =========================
     QUANTITY BUTTONS
  ========================= */

  const minusButtons =
    document.querySelectorAll('.qty-minus');

  const plusButtons =
    document.querySelectorAll('.qty-plus');

  minusButtons.forEach((button) => {

    button.addEventListener('click', function () {

      const input =
        this.parentElement.querySelector('input');

      let value = parseInt(input.value);

      if (value > 1) {
        input.value = value - 1;
      }

    });

  });

  plusButtons.forEach((button) => {

    button.addEventListener('click', function () {

      const input =
        this.parentElement.querySelector('input');

      let value = parseInt(input.value);

      input.value = value + 1;

    });

  });

  /* =========================
     SMOOTH ACCORDION
  ========================= */

  const accordionItems =
    document.querySelectorAll('.custom-pdp__accordion-item');

  accordionItems.forEach((item) => {

    const trigger =
      item.querySelector('.custom-pdp__accordion-trigger');

    const content =
      item.querySelector('.custom-pdp__accordion-content');

    trigger.addEventListener('click', () => {

      const isActive =
        item.classList.contains('active');

      accordionItems.forEach((accordion) => {

        accordion.classList.remove('active');

        accordion.querySelector(
          '.custom-pdp__accordion-content'
        ).style.maxHeight = null;

      });

      if (!isActive) {

        item.classList.add('active');

        content.style.maxHeight =
          content.scrollHeight + 'px';

      }

    });

  });

});